(function () {
  function initProofBar(scope) {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    var $root = scope ? $(scope) : $(document);
    $root.find('.actiiv-proof-bar__slider').each(function () {
      var $slider = $(this);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      var slideCount = $slider.children('.actiiv-proof-bar__slide').length;
      var visible = parseInt($slider.data('visible'), 10) || 4;
      if (slideCount <= visible) return;

      var autoplaySpeed = parseInt($slider.data('autoplay'), 10) || 4000;

      $slider.slick({
        slidesToShow: visible,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: autoplaySpeed,
        speed: 800,
        cssEase: 'ease-in-out',
        arrows: false,
        dots: false,
        infinite: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        adaptiveHeight: false,
        waitForAnimate: true,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: Math.min(2, visible),
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }

  function boot() {
    if (!window.jQuery || !window.jQuery.fn.slick) {
      window.setTimeout(boot, 100);
      return;
    }
    initProofBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProofBar(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var $ = window.jQuery;
    if (!$ || !$.fn.slick) return;
    $(event.target).find('.actiiv-proof-bar__slider.slick-initialized').slick('unslick');
  });
})();
